export function addUTMsToLogoLink() {
    var _a;
    try {
        const isEmbedded = window.self !== window.top;
        const medium = isEmbedded ? 'embed' : 'link';
        let widgetId = null;
        const embedEl = document.querySelector('[id^="pwWidget:"]');
        if (embedEl) {
            const parts = embedEl.id.split(':');
            if (parts.length === 2)
                widgetId = parts[1];
        }
        if (!widgetId) {
            const params = new URLSearchParams(window.location.search);
            widgetId = params.get('id');
        }
        if (!widgetId)
            widgetId = 'unknown-widget';
        const logoLink = (_a = document.querySelector('.pw-header .pw-logo')) === null || _a === void 0 ? void 0 : _a.closest('a');
        if (logoLink) {
            const url = new URL(logoLink.href);
            url.searchParams.set('utm_source', 'widget');
            url.searchParams.set('utm_medium', medium);
            url.searchParams.set('utm_campaign', widgetId);
            logoLink.href = url.toString();
        }
    }
    catch (e) {
        console.error('Injection failed:', e);
    }
}
